<template>
  <div v-if="isActiveSection">
    <b-container v-if="!isMobileScreen" class="bv-example-row award-highlights-section">
      <b-row>
        <b-col class="mb-4">
          <button :class="{
            'highlight-btn': component === 'video',
            'highlight-btn-active': component !== 'video'
          }" @click="component = 'video'">
            <i class="fas fa-video"></i>
          </button>
          <br />
          <button :class="{
            'highlight-btn': component === 'photos',
            'highlight-btn-active': component !== 'photos'
          }" @click="component = 'photos'">
            <i class="fas fa-images"></i>
          </button>
          <br />
          <button :class="{
            'highlight-btn': component === 'media',
            'highlight-btn-active': component !== 'media'
          }" @click="component = 'media'">
            <i class="fas fa-book-open"></i>
          </button>
        </b-col>
        <b-col cols="10">
          <vue-plyr class="mt-3 mb-4" v-if="component === 'video'">
            <div v-if="award.video_highlights" :data-plyr-provider="getHostName(award.video_highlights)"
              :data-plyr-embed-id="award.video_highlights"></div>
            <div v-else class="text-center"> There is no video </div>
          </vue-plyr>
          <div class="mt-3 mb-4" v-if="component === 'photos'">
            <viewer v-if="images.length" :images="images" :options="options" class="images clearfix">
              <template slot-scope="scope">
                <img v-for="{ id, image } in scope.images" :key="id" class="award-high-img" :src="image" />
              </template>
            </viewer>
            <div v-else class="text-center"> There is no photo </div>
          </div>
          <div class="mt-3 mb-4" v-if="component === 'media'">
            <b-row class="justify-content-md-center">
              <b-col v-if="award.post_guide" class="media-col">
                <pdf :src="award.post_guide" :page="1" :resize="true" style="width:100%;" />
                <a target="_blank" :href="award.post_guide" download>
                  <div class="media-download">
                    <i class="fa fa-download" aria-hidden="true"> </i>
                    Post Guide
                  </div>
                </a>
              </b-col>
              <b-col v-else>
                <div class="text-center"> There is no Guide file </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div v-else class="accordion" role="">
      <b-card no-body class="mb-1">
        <b-card-header v-b-toggle.video-highlights header-tag="header" role="tab">
          <div class="text-center">
            VIDEO HIGHLIGHTS
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="video-highlights" accordion="past-award-info" role="tabpanel" @hidden="pauseVideo">
          <b-card-body>
            <vue-plyr ref="highlightsPlayer">
              <div v-if="award.video_highlights" :data-plyr-provider="getHostName(award.video_highlights)"
                :data-plyr-embed-id="award.video_highlights"></div>
              <div v-else class="text-center"> There is no video </div>
            </vue-plyr>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header v-b-toggle.photo-sliter header-tag="header" role="tab">
          <div class="text-center">
            PHOTO SLIDER
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="photo-sliter" accordion="past-award-info" role="tabpanel">
          <b-card-body>
            <viewer v-if="images.length" :images="images" :options="options" class="images clearfix photo-slider">
              <template slot-scope="scope">
                <b-carousel id="carousel-1" :interval="10000" indicators background="#EBEBEB"
                  style="text-shadow: 1px 1px 2px #aaa; padding:1px">
                  <b-carousel-slide v-for="({ image, id }) in scope.images" :key="id" :img-src="image">
                  </b-carousel-slide>
                </b-carousel>
              </template>
            </viewer>
            <div v-else class="text-center"> There is no image </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header v-b-toggle.post-event-guide header-tag="header" role="tab">
          <div class="text-center">
            POST-EVENT GUIDE
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="post-event-guide" accordion="past-award-info" role="tabpanel">
          <b-card-body>
            <div v-if="award.post_guide" class="media-guide-area">
              <pdf :src="award.post_guide" :page="1" :resize="true" style="width:100%;" />
              <a :href="award.post_guide" target="_blank" :download="`Post_Event_Guide_${awardName(award.name)}`">
                <div class="media-download">
                  Post_Event_Guide_{{ awardName(award.name) }}{{ award.post_guide.slice(-4) }}
                </div>
              </a>
            </div>
            <p v-else class="text-center">There is no Guide file</p>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// eslint-disable-next-line import/extensions
import pdf from 'pdfvuer';

export default {
  name: 'Highlights',
  components: {
    pdf,
  },
  data() {
    return {
      component: 'media',
      images: [],
      options: {
        title: false,
        scalable: false,
        rotatable: false,
      },
      player: null,
    };
  },
  computed: {
    ...mapGetters({
      award: 'awards/award',
      isMobileScreen: 'isMobileScreen',
    }),
    isActiveSection() {
      return this.award && this.award.available_sections ? this.award.available_sections.includes('highlights') : false;
    },
  },
  async mounted() {
    if (this.$route.params.awardId) {
      this.images = await this.fetchGallery(this.$route.params.awardId);
    }
    if (this.isMobileScreen) this.player = this.$refs.highlightsPlayer.player;
  },
  methods: {
    ...mapActions({
      fetchGallery: 'awards/fetchGallery',
    }),
    pauseVideo() {
      this.player.pause();
    },
    awardName(name) {
      return name.split(' ').join('_');
    },
    getHostName(url) {
      let videoType = 'vimeo';
      const regex = new RegExp(
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?.*/,
      );
      if (regex.test(url)) {
        videoType = 'youtube';
      }
      return videoType;
    },
  },
};
</script>

<style scoped>
.award-highlights-section {
  background-color: white;
}

.highlight-btn {
  padding: 10px 13px 11px 10px;
  background-color: #BD9D5F;
  border: unset;
  color: white;
  margin-top: 15px;
  width: 40px;
  height: 40px;
}

.highlight-btn-active {
  padding: 10px 13px 11px 10px;
  background-color: white;
  border: unset;
  color: #BD9D5F;
  margin-top: 15px;
  width: 40px;
  height: 40px;
  border-bottom: 1px solid #BD9D5F;
}

.highlight-btn>i,
.highlight-btn-active>i {
  font-size: 20px;
}

.award-high-img {
  width: 95px;
  margin: 10px;
  height: 65px;
  object-fit: cover;
  cursor: pointer;
}

.media-col {
  text-align: center;
}

.media-download {
  background: #BD9D5F;
  color: white;
  width: 100%;
  height: 24px;
  text-align: center;
  cursor: pointer;
}

.media-download>p {
  font-size: 10px;
  font-family: Arial;
  line-height: 1.17;
}

.media-download:hover {
  opacity: 0.5;
  transition: 0.3s;
}

.download-btn {
  background: transparent;
  height: 23px;
  font-size: 12px;
  border: unset;
}

.media-download>a {
  color: white;
}

@media (max-width: 1024px) {
  .event-high-img {
    width: 95px;
    margin: 10px;
    height: 65px;
    object-fit: cover;
    cursor: pointer;
  }

  .media-download {
    background: #fff;
    color: #BD9D5F;
    text-align: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    font-size: 11px;
    border-top: 2px solid #EBEBEB;
    height: 2rem;
  }

  .media-guide-area {
    margin-top: 4px;
  }

  .media-download:hover {
    opacity: 0.5;
    transition: 0.3s;
  }

  .photo-slider>>>#carousel-1>.carousel-inner>.carousel-item>img {
    height: 40vh;
    object-fit: cover;
  }

  .card {
    border-radius: 0 10px 10px 10px !important;
    overflow: hidden;
  }

  .card>.card-header>div {
    font-size: 13px;
  }

  .card>.collapse>.card-body {
    padding: 0;
  }

  .card>header i {
    position: absolute;
    top: 16px;
    right: 20px;
  }

  header .fa-chevron-up {
    display: inline-block;
  }

  header .fa-chevron-down {
    display: none;
  }

  .card>.collapsed .fa-chevron-down {
    display: inline-block;
  }

  .card>.collapsed .fa-chevron-up {
    display: none;
  }
}
</style>
